import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type QuickLoginInitParams, type QuickLoginInitResponse} from './types'

export async function init(
  _agent: BskyAgent,
  params: QuickLoginInitParams,
  options?: {signal?: AbortSignal},
): Promise<QuickLoginInitResponse> {
  return wsocFetch<QuickLoginInitResponse>(
    xrpcPath('eu.wsocial.quicklogin.init'),
    {body: params, signal: options?.signal},
  )
}
